import { deriveSipPlansView } from '../../plans-v4/sip/plans-list/deriveSipPlansView'
import {
  mockLumpsumAllocationPlans,
  mockLumpsumIdealPlans,
  mockLumpsumRebalancePlans
} from './lumpsum/lists'
import { ALLOCATION_PLANS_MOCK_CONFIG } from '../mockConfig'
import { mockSipPlansOverview, SipPlansMockScenario } from './sip/overview'

const BLUR_CATEGORY_COUNT = 2

/** Decorative list data behind subscription-lock blur (not MSW / not live API). */
export const ALLOCATION_BLURRED_CATEGORIES =
  mockLumpsumAllocationPlans().categories?.slice(0, BLUR_CATEGORY_COUNT) ?? []
export const IDEAL_BLURRED_CATEGORIES =
  mockLumpsumIdealPlans().categories?.slice(0, BLUR_CATEGORY_COUNT) ?? []
export const REBALANCE_BLURRED_CATEGORIES =
  mockLumpsumRebalancePlans().categories?.slice(0, BLUR_CATEGORY_COUNT) ?? []

const sipBlurDerived = deriveSipPlansView(
  mockSipPlansOverview(SipPlansMockScenario.NORMAL, ALLOCATION_PLANS_MOCK_CONFIG.sip)
)
export const SIP_YOUR_PLAN_BLURRED_CATEGORIES = sipBlurDerived.yourPlanCategories.slice(
  0,
  BLUR_CATEGORY_COUNT
)
export const SIP_IDEAL_BLURRED_CATEGORIES = sipBlurDerived.idealCategories.slice(
  0,
  BLUR_CATEGORY_COUNT
)
